import { Component, Inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PageService } from '../../services/page.service';

@Component({
  selector: 'mob-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

    constructor(@Inject(PageService) public pageService: PageService, @Inject(Router) public router: Router) { }

    ngOnInit() {
    }

    goBack(){
        window.history.back();
    }

    goHome(){
        this.pageService.goToLanding();
    }
}
